export default function AlertIcon() {
  return (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18.3147 22H5.68669C2.94989 22 1.16925 19.1185 2.39352 16.6701L8.70752 4.0359C10.0648 1.32135 13.9366 1.32135 15.2939 4.03599L21.6079 16.6701C22.8321 19.1185 21.0515 22 18.3147 22ZM14.3995 4.48345C13.4108 2.50605 10.5906 2.50605 9.60191 4.48336L3.28787 17.1177C2.39626 18.9008 3.69323 20.9996 5.68669 20.9996H18.3147C20.3082 20.9996 21.6051 18.9008 20.7135 17.1176L14.3995 4.48345ZM12.5009 15.193V8.80735C12.5009 8.53109 12.277 8.30714 12.0009 8.30714C11.7248 8.30714 11.5009 8.53109 11.5009 8.80735V15.193C11.5009 15.4692 11.7248 15.6932 12.0009 15.6932C12.277 15.6932 12.5009 15.4692 12.5009 15.193ZM12.0009 18.4981C11.6339 18.4981 11.3359 18.1999 11.3359 17.8328C11.3359 17.4656 11.6339 17.1675 12.0009 17.1675C12.3679 17.1675 12.6659 17.4656 12.6659 17.8328C12.6659 18.1999 12.3679 18.4981 12.0009 18.4981Z'
        fill='#8C5F0F'
      />
    </svg>
  );
}
